function ColorPattern({ value }) {
  return (
    <div className="ColorPattern" style={{ backgroundColor: value }}/>
  )
}

export default ColorPattern
